const notificationInfoDataset =[
  // leaving 'reminder' notifications here in case decide to reinstate in the future, but rigth now
  // these are not being triggered - believe that awards serve this purpose going forward...?
   {
    notificationName: "jobChange",
        notificationCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-college-position",
        imageSrc: "graduationHat.png"
  },
   {
    notificationName: "moneyBuilderReminder",
        notificationCategory: "information",
        className: "small_sign_thumbnail_img good-news-moneyBuilder-position",
        imageSrc: "moneyBuilder.jpg"
  },
  {
    notificationName: "creditCardReminder",
        notificationCategory: "information",
        className: "small_sign_thumbnail_img good-news-creditCard-position",
        imageSrc: "creditCard.png"
  },
  {
    notificationName: "timeWizardReminder",
        notificationCategory: "goodNews",
        className: "small_sign_thumbnail_img good-news-timeWizard-position",
        imageSrc: "timeWizard.png"
  },
   {
    notificationName: "federalTax",
        notificationCategory: "information",
        className: "small_sign_thumbnail_img good-news-investments-position",
        imageSrc: "Taxes.png"
  },
  {
    notificationName: "CDMatures",
        notificationCategory: "information",
        className: "small_sign_thumbnail_img good-news-investments-position",
        imageSrc: "CD.png"
  },
  
];

export default notificationInfoDataset;